import SineBrowserStorage from '@sine/sine-browser-storage';

const oneYearInMs = 31556952000;

SineBrowserStorage.initialize({
  localStorage: window.localStorage,
  sessionStorage: window.sessionStorage,
  disableSecureCookies: window.env.DISABLE_SECURE_COOKIES,
  cookieExpiryMs: oneYearInMs,
});

const { storage, sessionStorage } = SineBrowserStorage.getInstance();

export const getStoredData = (storeKey: string) => JSON.parse(storage.getItem(storeKey)!);
export const setStoredData = (storeKey: string, data: string) => storage.setItem(storeKey, data);
export { storage, sessionStorage };
